export default (theme) => ({
    copyRightContainer: {
        bottom: "2%",
        position: "absolute",
        width: "100%",
    },
});
